const CODE_MESSAGES = Object.freeze({
  INVALID_LOCATION_ALLOCATION:
    'One or more selected locations are no longer available for this account. Review Location Access and try again.',
  INVALID_ACCOUNT_ALLOCATION:
    'One or more selected accounts are unavailable. Review Account Access and try again.',
  ACCOUNT_MISMATCH:
    'The selected account does not match this request. Refresh the page and try again.',
});

const rawMessage = (value) => {
  if (value && typeof value === 'object') {
    if (typeof value.code === 'string' && CODE_MESSAGES[value.code]) {
      return CODE_MESSAGES[value.code];
    }
    if (typeof value.error === 'string') return value.error.trim();
    if (typeof value.message === 'string') return value.message.trim();
  }

  return typeof value === 'string' ? value.trim() : '';
};

/**
 * Convert API validation details into language intended for portal users.
 * The backend can retain stable field/code metadata while screens avoid
 * exposing transport and database names such as companyNumber/account_id.
 */
export const apiErrorMessageForUser = (value, fallback = '') => {
  const message = rawMessage(value);
  if (!message) return fallback;

  if (/allocated location does not belong|invalid location allocation/i.test(message)) {
    return CODE_MESSAGES.INVALID_LOCATION_ALLOCATION;
  }
  if (/location(?:_id)? .*does not belong|location does not belong/i.test(message)) {
    return 'The selected location does not belong to this account.';
  }
  if (/user .*does not belong/i.test(message)) {
    return 'The selected user does not belong to this account.';
  }
  if (/role .*does not belong/i.test(message)) {
    return 'The selected role does not belong to this account.';
  }
  if (/unknown or inactive (?:company|account)|allocated account is unknown or inactive/i.test(message)) {
    return 'The selected account is unavailable or inactive.';
  }
  if (/companynumber must identify an active corporate account/i.test(message)) {
    return 'Please select an active Corporate account.';
  }
  if (/companynumber must identify an active account/i.test(message)) {
    return 'Please select an active account.';
  }
  if (/(?:companynumber|account_id|company_id) is required/i.test(message)) {
    return 'Please select an account.';
  }
  if (
    /companynumber does not match/i.test(message)
    || /(?:account_id|company_id) does not match companynumber/i.test(message)
  ) {
    return CODE_MESSAGES.ACCOUNT_MISMATCH;
  }

  return message
    .replace(/\bcompanyNumber\b/gi, 'the selected account')
    .replace(/\b(?:account_id|company_id|Account_ID)\b/g, 'the selected account')
    .replace(/\blocation_id\b/gi, 'the selected location');
};
